import * as React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Footer from "../components/footer.js"
import Header from "../components/header.js"
import Announcement from "../components/announcement.js"

import Favicon from "../images/bordr-favicon.png"

const CheckoutPage =  () => {
    return (
        <main>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="shortcut icon" type="image/png" href={Favicon}/>
                <meta name="author" content="Bordr Team"></meta>
                <meta name="description" content="Order your Portugal NIF online from the comfort of your living room. All you need is a scanned image of your US passport, a proof of address, and a credit card to get started."></meta>
                {/* Open graph data */}
                <meta property="og:title" content="Bordr - Portugal NIF Online Order Form" />
                <meta property="og:description" content="Order your Portugal NIF online from the comfort of your living room. All you need is a scanned image of your US passport, a proof of address, and a credit card to get started." />
                <title>Bordr - Portugal NIF Online Order Form</title>        
                {/* paperform */}
                <script type="text/javascript" async defer>{'(function() {var script = document.createElement("script"); script.src = "https://paperform.co/__embed"; document.body.appendChild(script); })()'}</script>
                {/* iubenda popups */}
                <script type="text/javascript" async defer>{'(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'}</script>
                {/* helpscout beacon */}
                <script type="text/javascript" async defer>{'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});'}</script>
                <script type="text/javascript" async defer>{'window.Beacon("init", "1bc22ba4-9a9a-4d05-a0b0-5e10bc8614dc")'}</script>
            </Helmet>
            <Announcement />
            <section className="bg-gray-50 pb-12">
                <Header />
                <div className="max-w-screen-xl mx-auto px-6 w-full md:w-2/3">
                    {/* <div className="pt-16 mb-8 md:mb-10 text-center bg-gray-50">
                        <h1 className="text-3xl font-bold">We'll be right back!</h1>
                        <p className="text-base mt-4">Thank you for your interest in our NIF service. We've run into some issues and aren't accepting new NIF orders at the moment. Please click on the button below to get notified when we're back up and running.<span role="img" aria-label="smiley-face">😊</span></p>
                        <div className="mt-8 mb-12"> 
                            <Link to="https://airtable.com/shrw6u3B4gk71JoQ4" target="_blank" className="btn-blue">Notify me when you're back</Link>
                        </div>                        
                    </div> */}
                </div>
                <div className="pt-16" data-paperform-id="cdouekb9"></div>
            </section>
            <Footer />
        </main>         
    )    
}
export default CheckoutPage